import React from "react";

interface TimeIconProps {
  color?: string;
}

export default function TimeIcon({ color = "#fff" }: TimeIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="21.29"
      viewBox="0 0 24 21.29"
    >
      <g id="Age" transform="translate(-22.5 -52.998)">
        <path
          id="Caminho_10332"
          data-name="Caminho 10332"
          d="M15.359,3A10.647,10.647,0,0,0,4.408,13.644H2.292a.585.585,0,0,0-.414,1.005l3.3,3.311a.585.585,0,0,0,.84,0l3.3-3.311A.588.588,0,0,0,8.9,13.644H6.773a8.275,8.275,0,0,1,8.4-8.278,8.383,8.383,0,0,1,8.16,8.16,8.283,8.283,0,0,1-8.278,8.4,8.154,8.154,0,0,1-5.061-1.75,1.176,1.176,0,0,0-1.561.095,1.2,1.2,0,0,0,.095,1.774,10.637,10.637,0,0,0,17.171-8.7A10.768,10.768,0,0,0,15.359,3Zm-.6,5.913a.893.893,0,0,0-.887.887v4.352a1.2,1.2,0,0,0,.579,1.017l3.69,2.188a.888.888,0,0,0,.911-1.525l-3.406-2.022V9.789A.883.883,0,0,0,14.756,8.913Z"
          transform="translate(20.802 50.002)"
          fill={color}
        />
      </g>
    </svg>
  );
}
